module.exports = __webpack_public_path__ + "img/sign.6fefb740.svg";